import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IClinicGroomerMapBody, IClinicGroomerMapUpdateBody } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useClinicGroomerMappingAddAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (clinicId: string, body: IClinicGroomerMapUpdateBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const url = `${CONFIGURATION_APIS.CLINIC_GROOMER_MAP_UPDATE.baseURL}${clinicId}/`;
        const response = await axios.post(
          url,
          body,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        toast.success("Groomers mapped to clinic");
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
        
        throw error;
      }
    },
    [captureError, configuration, sendCurl],
  );

  return { execute };
};
